import type { Toast } from '#ui/composables'
import type { StringOrVNode } from '#ui/types/utils'

type KsToastMessage =
  | string
  | {
    message?: StringOrVNode
    duration?: number
    persistent?: boolean
    buttons?: Array<{ text: string, onClick: () => void }>
    onClose?: () => void
  }

const DEFAULT_DURATION_MS = 4000

function createToast(message: KsToastMessage, icon: Toast['icon'], color: Toast['color']): Partial<Toast> {
  return {
    icon,
    color,
    'title': typeof message === 'string' ? message : message.message,
    'progress': false,
    'duration': typeof message === 'string' ? DEFAULT_DURATION_MS : (message.persistent ? -1 : (message.duration ?? DEFAULT_DURATION_MS)),
    'actions': typeof message === 'string'
      ? undefined
      : message.buttons?.map((btn) => ({
          onClick: btn.onClick,
          label: btn.text,
        })),
    'onUpdate:open': (isOpen) => {
      if (!isOpen && typeof message !== 'string' && message.onClose) {
        message.onClose()
      }
    },
  }
}

export function useUiToast(): Record<'info' | 'success' | 'error', (message: KsToastMessage) => void> {
  const toast = useToast()

  return {
    info(message) {
      return toast.add(createToast(message, 'far:info-circle', 'info'))
    },
    success(message) {
      return toast.add(createToast(message, 'far:circle-check', 'success'))
    },
    error(message) {
      return toast.add(createToast(message, 'far:circle-xmark', 'error'))
    },
  }
}
